import React, { useState } from 'react';
import InviteTeamCard from './InviteTeamCard';
import { v4 as uuidv4 } from 'uuid';
import { API_ENDPOINTS } from '../../../../utils/endpoints';
import { http_get, http_post } from '../../../../utils/api_client';
import { toast } from 'react-toastify';
import { useDispatch } from 'react-redux';
import { setAdminUsers } from '../../../../../../redux/teamSlice';

function InviteTeam() {
  const [listInviteCard, setListInviteCard] = useState([
    { id: uuidv4(), email: '', role: '' },
  ]);

  const dispatch = useDispatch();

  const handleAddTeamClick = () => {
    setListInviteCard([
      ...listInviteCard,
      { id: uuidv4(), email: '', role: '' },
    ]);
  };

  const handleFieldChange = (id, key, value) => {
    const listCard = [...listInviteCard];
    listCard.forEach((card) => {
      if (card.id === id) {
        card[key] = value;
      }
    });
    setListInviteCard([...listCard]);
  };

  const handelCardRemove = (id) => {
    const listCard = listInviteCard.filter((card) => card.id !== id);
    setListInviteCard([...listCard]);
  };

  const handleSendInvites = () => {
    const data = listInviteCard.map((card) => ({
      email: card.email,
      role: card.role,
    }));
    http_post(API_ENDPOINTS.POST_INVITE_TEAM, {
      invites: data,
    })
      .then((res) => {
        setListInviteCard([
          { id: uuidv4(), email: '', role: '' },
        ]);
        toast.success("Invites sent successfully!");
        fetchTeamMembers();
      })
      .catch((err) => {
        toast.error(err?.response?.data?.error || err?.response?.data?.message || 'Unable to send invites.');
      });
  };

  // Function to fetch team members
  const fetchTeamMembers = () => {
    http_get(API_ENDPOINTS.GET_TEAM_MEMBERS, {
      page: 1,
      limit: 20,
    })
      .then((res) => {
        if (res.data.members) {
          dispatch(setAdminUsers(res.data.members));
        }
      })
      .catch((err) => {
        throw new Error('Failed to fetch profile');
      });
  };

  return (
    <>
      <div className="flex-invite-team">
        <div className="left-invite-team">
          <h4 className="label-invite-team">Invite team members</h4>
          <p className="text-invite-team">
            Get your projects up and running faster by inviting your team to
            collaborate.
          </p>
        </div>
        <div className="right-invite-team">
          {listInviteCard.map((item, index) => (
            <InviteTeamCard
              key={index}
              data={item}
              onFieldChange={handleFieldChange}
              onCardRemove={handelCardRemove}
              hideRemoveBtn={index === 0}
            />
          ))}
          <div className="action-invite-team">
            <div className="cover-button-add-team" onClick={handleAddTeamClick}>
              <button className="button-add-team" type="button">
                <span className="icon-button-add-team">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="21"
                    height="21"
                    viewBox="0 0 21 21"
                    fill="none"
                  >
                    <path
                      d="M10.073 4.98242V16.6491M4.23969 10.8158H15.9064"
                      stroke="currentColor"
                      strokeWidth="1.66667"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </span>
                <span className="text-button-add-team">Add another</span>
              </button>
            </div>
            <div className="cover-submit-btn">
              <button
                className="btn-invite-team"
                type="button"
                onClick={handleSendInvites}
              >
                <span className="icon-btn-invite-team">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="25"
                    height="25"
                    viewBox="0 0 25 25"
                    fill="none"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M8.67906 6.81641H8.64859H8.64857C7.99561 6.8164 7.46159 6.81639 7.0276 6.85185C6.57838 6.88855 6.17266 6.96684 5.79376 7.1599C5.20076 7.46205 4.71864 7.94417 4.41649 8.53716C4.22343 8.91606 4.14515 9.32178 4.10844 9.77101C4.07298 10.205 4.07299 10.739 4.073 11.392V11.392V11.4225V14.978V15.0085V15.0085C4.07299 15.6615 4.07298 16.1955 4.10844 16.6295C4.14515 17.0787 4.22343 17.4844 4.41649 17.8633C4.71864 18.4563 5.20076 18.9384 5.79376 19.2406C6.17266 19.4336 6.57838 19.5119 7.0276 19.5486C7.4616 19.5841 7.99562 19.5841 8.64859 19.5841H8.67906H15.4669H15.4974C16.1504 19.5841 16.6844 19.5841 17.1184 19.5486C17.5676 19.5119 17.9733 19.4336 18.3522 19.2406C18.9452 18.9384 19.4274 18.4563 19.7295 17.8633C19.9226 17.4844 20.0009 17.0787 20.0376 16.6295C20.073 16.1955 20.073 15.6615 20.073 15.0085V14.978V11.4225V11.392C20.073 10.739 20.073 10.205 20.0376 9.77101C20.0009 9.32178 19.9226 8.91606 19.7295 8.53716C19.4274 7.94417 18.9452 7.46205 18.3522 7.1599C17.9733 6.96684 17.5676 6.88855 17.1184 6.85185C16.6844 6.81639 16.1504 6.8164 15.4974 6.81641H15.4974H15.4669H8.67906ZM6.72402 8.36159C6.83357 8.33625 6.9698 8.31597 7.14604 8.30157C7.51381 8.27152 7.98821 8.27095 8.67906 8.27095H15.4669C16.1578 8.27095 16.6322 8.27152 17 8.30157C17.1762 8.31597 17.3124 8.33625 17.422 8.36159L14.1823 11.1963C13.7154 11.6048 13.3957 11.8839 13.1295 12.083C12.8706 12.2766 12.7059 12.3603 12.5634 12.4024C12.2433 12.4971 11.9027 12.4971 11.5826 12.4024C11.4401 12.3603 11.2754 12.2766 11.0165 12.083C10.7503 11.8839 10.4306 11.6048 9.96366 11.1963L6.72402 8.36159ZM5.64908 9.35377C5.60905 9.47958 5.57801 9.6465 5.55816 9.88945C5.52811 10.2572 5.52754 10.7316 5.52754 11.4225V14.978C5.52754 15.6689 5.52811 16.1433 5.55816 16.511C5.58751 16.8703 5.64134 17.0633 5.7125 17.203C5.8752 17.5223 6.1348 17.7819 6.45411 17.9446C6.59378 18.0157 6.78677 18.0696 7.14604 18.0989C7.51381 18.129 7.98821 18.1295 8.67906 18.1295H15.4669C16.1578 18.1295 16.6322 18.129 17 18.0989C17.3592 18.0696 17.5522 18.0157 17.6919 17.9446C18.0112 17.7819 18.2708 17.5223 18.4335 17.203C18.5047 17.0633 18.5585 16.8703 18.5878 16.511C18.6179 16.1433 18.6185 15.6689 18.6185 14.978V11.4225C18.6185 10.7316 18.6179 10.2572 18.5878 9.88945C18.568 9.6465 18.5369 9.47958 18.4969 9.35377L15.1402 12.2909L15.119 12.3095C14.6785 12.6949 14.3169 13.0113 14.0006 13.2478C13.672 13.4936 13.3494 13.6868 12.9759 13.7973C12.3866 13.9715 11.7594 13.9715 11.1701 13.7973C10.7966 13.6868 10.474 13.4936 10.1454 13.2478C9.82912 13.0113 9.46756 12.695 9.02705 12.3095L9.00583 12.2909L5.64908 9.35377Z"
                      fill="currentColor"
                    />
                  </svg>
                </span>
                <span className="text-btn-invite-team">Send invites</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <hr style={{ marginTop: 60, marginBottom: 60 }} />
    </>
  );
}

export default InviteTeam;
